import { Box, Link } from "@material-ui/core";
import { Title } from "react-admin";

import { AppResource } from "../../types/resource.types";

const Terms = () => {
  return (
    <>
      <Title title="Terms And Conditions" />
      <Box display="flex" alignItems="center" justifyContent="center" mt={5}>
        <Link target="_blank" href={`/${AppResource.termsEN}`} style={{ margin: "0 10px" }} variant="body1">
          English Terms
        </Link>
        <Link target="_blank" href={`/${AppResource.termsAR}`} style={{ margin: "0 10px" }} variant="body1">
          Arabic Terms
        </Link>
      </Box>
    </>
  );
};

export default Terms;
